/** localStorage key of the UI language chosen by the user. */
export const LANG_STORAGE_KEY = 'tt.lang';

const browserStorage = (): Storage | null => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

/** The stored UI language when it is one of `available`, else `defaultLang`. Never throws (blocked storage). */
export function initialLang(available: string[], defaultLang: string, storage: Storage | null = browserStorage()): string {
  try {
    const stored = storage?.getItem(LANG_STORAGE_KEY);
    return stored && available.includes(stored) ? stored : defaultLang;
  } catch {
    return defaultLang;
  }
}

/** Remembers the UI language for the next visit; a blocked storage only loses the preference. */
export function storeLang(lang: string, storage: Storage | null = browserStorage()): void {
  try {
    storage?.setItem(LANG_STORAGE_KEY, lang);
  } catch {
    // ignore: the language still changes for this session
  }
}
